// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BotCommandsList__container-f63c11 {
  max-height: 178px;
  background-color: var(--base-0);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1px;
  border-top: 1px solid var(--base-20);
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/BotCommandsList/styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  max-height: 178px;\n  background-color: var(--base-0);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 1px;\n  border-top: 1px solid var(--base-20);\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BotCommandsList__container-f63c11`
};
module.exports = ___CSS_LOADER_EXPORT___;
